// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__it179","main":"layout_main__zOj9C"};